
export const isVectorImage = (fileName) => {
    const extension = fileName.toLowerCase().substring(fileName.lastIndexOf('.') + 1);
    if (extension === 'eps' || extension === 'pdf' || extension === 'ai') {
        return true;
    }
    return false;
};
